// src/AuthService.js
import Store from "./Store";
const url = Store.getState().url.url;
class AuthService {
  static async CheckToken(token) {
    try {
      const response = await fetch(`${url}auth/checkToken/${token}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          accept: "text/plain",
        },
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message);
      }

      return response.json();
    } catch (error) {
      throw new Error("failed");
    }
  }
  static async changePassword(token, password) {
    try {
      const response = await fetch(
        `${url}auth/ChangePassword/${token}/${password}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message);
      }

      return response.json();
    } catch (error) {
      throw new Error("Login failed");
    }
  }
  static async sendPassword(email) {
    console.log(email);
    try {
      const response = await fetch(`${url}auth/ChangePassword/${email}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          accept: "text/plain",
        },
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message);
      }

      return response.json();
    } catch (error) {
      throw new Error("Login failed");
    }
  }
  static async login(username, password) {
    console.log(username);
    console.log(password);
    try {
      const response = await fetch(`${url}auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, password }),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message);
      }

      return response.json();
    } catch (error) {
      throw new Error("Login failed");
    }
  }
}

export default AuthService;
